import React, { useCallback } from 'react';
import { useLocalSearchParams, useRouter } from 'expo-router';

import { useIsUpsellScreenEnabled } from '../../hooks';
import { useReorderNavigation } from '../../hooks/useReorderNavigation';
import { DeliveryCustomization } from './components';

// ─────────────────────────────────────────────────────────────────────────────

export const CustomizationDeliveryScreen = () => {
  const router = useRouter();
  const routeParams = useLocalSearchParams<CustomizationDeliveryScreenRouteParams>();

  const {
    addressId,
    productSlug,
    reorderLineItemId,
    sharedLineItemId,
    sharedLineItemSlug,
    unavailableIngModal,
  } = routeParams;

  const { finishReorder } = useReorderNavigation();
  const isUpsellScreenEnabled = useIsUpsellScreenEnabled();

  // ─── Helpers ─────────────────────────────────────────────────────────

  const handleAddLineItemToCart = useCallback(() => {
    if (sharedLineItemId) {
      finishReorder(undefined, addressId);
      return;
    }

    if (isUpsellScreenEnabled) {
      router.replace('/upsell');
      return;
    }

    router.replace({
      pathname: '/bag',
      params: { referrer: 'DeliveryMenu' },
    });
  }, [addressId, finishReorder, isUpsellScreenEnabled, router, sharedLineItemId]);

  // ─────────────────────────────────────────────────────────────────────

  return (
    <DeliveryCustomization
      addressId={addressId}
      productSlug={productSlug}
      reorderLineItemId={reorderLineItemId}
      sharedLineItemId={sharedLineItemId}
      sharedLineItemSlug={sharedLineItemSlug}
      shouldShowUnavailableIngredientsModal={unavailableIngModal !== 'false'}
      onAddLineItemToCart={handleAddLineItemToCart}
      isEditProductMode={false}
    />
  );
};

// ─── Types ───────────────────────────────────────────────────────────────────

type CustomizationDeliveryScreenRouteParams = {
  addressId: string;
  productSlug: string;
  reorderLineItemId?: string;
  sharedLineItemId?: string;
  sharedLineItemSlug?: string;
  unavailableIngModal?: string;
};
